/**
 * Mirrors com.medprompt.patient.Significance
 */
export const Significance = Object.freeze({
  ADMINISTRATIVE: 'ADMINISTRATIVE',
  MAJOR: 'MAJOR',
  MINOR: 'MINOR',
});
